import {create} from "zustand";
import {ChatStore, NewChatData} from "./chat.types";

const initialData: NewChatData = {
    chat_name: '',
    person_to_copy: '',
    chat_type: 'Whatsapp',
    chat_file: null,
    chat_avatar: null,
    voice_sample: null,
    chat_members: null,
    chat_gender: 'male',
    chat_language: {code: 'en', name: 'English'}
};

export const useNewChatStore = create<ChatStore>((set) => ({
    currentStep: 1,
    newChatData: initialData,

    setStep: (step) => set({currentStep: step}),

    updateChatData: (data) =>
        set((state) => ({
            newChatData: {
                ...state.newChatData,
                ...data
            }
        })),

    resetChat: () => set({currentStep: 1, newChatData: initialData})
}));


export const useCurrentChatStore = create<any>((set, get) => ({
    currentChat: null,
    userChats: [],

    // Добавить новый чат в список пользователя
    pushNewChatToUserChats: (chat: any) => {
        set((state: any) => ({
            userChats: [...state.userChats, chat],
            currentChat: chat, // можно сразу сделать текущим
        }));
    },

    // Обновить данные текущего чата
    updateCurrentChat: (data: any) => {
        set((state: any) => {
            const updatedCurrentChat = {
                ...(state.currentChat ?? {}),
                ...data,
            };

            const updatedUserChats = state.userChats.map((c: any) =>
                c.id === updatedCurrentChat.id ? updatedCurrentChat : c
            );

            return {
                currentChat: updatedCurrentChat,
                userChats: updatedUserChats,
            };
        });
    },

    // Сбросить текущий чат
    resetChat: () => set({currentChat: null}),
}));
